function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0xfec59a;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};

    var sprites;

    var counter;
    var itemsPositionsObject = { traccia_rossa: { x: 482, y: 292, w: 16, h: 18, n: "traccia_rossa" }, tessera: { x: 465, y: 272, w: 51, h: 58, n: "tessera" }, alieno_03: { x: 8, y: 0, w: 857, h: 600, n: "alieno_03" }, alieno_02: { x: 8, y: 0, w: 857, h: 600, n: "alieno_02" }, alieno_01: { x: 8, y: 0, w: 857, h: 600, n: "alieno_01" } };
    var gameScene;



    /**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {
        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
        cycleGame();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 800);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {
        gameData.numItems = 1;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(335, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('alieni', itemsPositionsObject);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        //  game.gameContainer.addChild(counter.container);
    }


    function positionGameItems() {
        sprites.btn_gioca.x = 935;
        sprites.btn_gioca.y = 495;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);

    }

    function onAnswerWrong(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}

function Scene(sceneName, positions) {
    var name = sceneName;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    // var animating;
    var currentState;
    this.setState = setState;

    //
    // var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;

    var gridsContainer = new Container();
    var buttonsContainer = new Container();
    var feedbackItemsContainer = new Container();
    container.addChild(gridsContainer);
    container.addChild(feedbackItemsContainer);
    container.addChild(buttonsContainer);
    buttonsContainer.interactive = true;
    buttonsContainer.on('pointertap', onClick);

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);
    var iterations = 0;
    var sceneElements = {};
    var gridNames = ['01', '02', '03'];
    var currentGridName;
    var currentGridClicks;
    var grids = {
        '01': [2, 3, 4, 5, 6, 8, 11, 13, 15, 16, 18, 23, 24, 25, 26, 27, 33, 34, 35, 45, 46, 56, 57],
        '02': [3, 4, 5, 6, 8, 12, 13, 15, 16, 18, 21, 23, 24, 25, 26, 27, 34, 35, 36, 45, 55, 56, 57],
        '03': [3, 4, 5, 6, 7, 11, 12, 13, 15, 16, 17, 23, 24, 25, 26, 34, 35, 36, 45, 53, 54, 55]
    };
    var gridElementProps = {
        items: [],
        gridX: 425,
        gridY: 32,
        gridRads: -0.172,
        gridWidth: 7,
        gridHeight: 10,
        w: 43,
        h: 50.35
    };
    var feedbackElementProps = {
        items: [],
        gridX: 240,
        gridY: 72,
        gridRads: 0.182,
        gridWidth: 7,
        gridHeight: 10,
        w: 13.6,
        h: 15.55
    };
    buttonsContainer.position.set(gridElementProps.gridX, gridElementProps.gridY);
    buttonsContainer.rotation = gridElementProps.gridRads;

    feedbackItemsContainer.position.set(feedbackElementProps.gridX, feedbackElementProps.gridY);
    feedbackItemsContainer.rotation = feedbackElementProps.gridRads;

    initScene();

    function initScene() {
        var i, ii;
        var itemName;
        var spriteItem;
        var pos;
        for (i = 0; i < gridNames.length; i++) {
            itemName = gridNames[i];
            spriteItem = game.sprites['alieno_' + itemName];
            pos = positions['alieno_' + itemName];
            spriteItem.position.set(pos.x, pos.y);

            gridsContainer.addChild(spriteItem);
            sceneElements['alieno_' + itemName] = spriteItem;

        }

        for (i = 0; i < gridElementProps.gridWidth; i++) {
            for (ii = 0; ii < gridElementProps.gridHeight; ii++) {
                var itemIndex = i + ii;
                itemName = "t_" + itemIndex;

                pos = { x: i * gridElementProps.w, y: ii * gridElementProps.h };
                var graphics = new Graphics();

                graphics.beginFill(0x706f5a);
                graphics.lineStyle(1, 0x000000);
                graphics.drawRect(0, 0, gridElementProps.w, gridElementProps.h);
                graphics.endFill();

                spriteItem = graphics;
                spriteItem.position.set(pos.x, pos.y);

                spriteItem.interactive = true;
                spriteItem.buttonMode = true;
                buttonsContainer.addChild(spriteItem);
                sceneElements[itemName] = spriteItem;

                gridElementProps.items.push(spriteItem);
                //
                graphics = new Graphics();

                graphics.beginFill(0xff0000);
                graphics.lineStyle(1, 0x000000);
                graphics.drawRect(0, 0, feedbackElementProps.w, feedbackElementProps.h);
                graphics.endFill();

                spriteItem = graphics;
                pos = { x: i * feedbackElementProps.w, y: ii * feedbackElementProps.h };
                spriteItem.position.set(pos.x, pos.y);


                feedbackItemsContainer.addChild(spriteItem);
                sceneElements['fdbk_' + itemName] = spriteItem;

                feedbackElementProps.items.push(spriteItem);
            }
        }



    }


    function clear() {


    }

    function reset() {
        gridNames = _.shuffle(gridNames);
        iterations = 0;
        setState('newGrid');
    }

    function reseItems() {
        var i;
        var itemName;
        for (i = 0; i < gridNames.length; i++) {
            itemName = gridNames[i];
            sceneElements["alieno_" + itemName].visible = false;
        }
        for (i = 0; i < gridElementProps.items.length; i++) {
            gridElementProps.items[i].alpha = 0;
            feedbackElementProps.items[i].alpha = 0;
        }
        currentGridClicks = [];
    }


    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newGrid':
                reseItems();


                gridNames.push(gridNames.shift());
                currentGridName = gridNames[0];
                sceneElements['alieno_' + currentGridName].visible = true;
                loopSequence = [renderOnce];
                break;
            case 'ready':

                break;
            case 'animating':


                break;
        }
        currentState = state;

    }

    function onClick(e) {
        var i;
        var pos;
        var el = e.target;
        var ok;
        if (currentState === "ready") {
            var btnIndex = gridElementProps.items.indexOf(e.target);


            if (btnIndex === -1) {
                return false;
            }
            i = currentGridClicks.indexOf(btnIndex);
            if (i >= 0) {
                currentGridClicks.splice(i, 1);
                el.alpha = 0;
                feedbackElementProps.items[btnIndex].alpha = 0;

            } else {
                currentGridClicks.push(btnIndex);
                el.alpha = 1;
                //var sorted = currentGridClicks.sort(function (a, b) { return a > b;})
                // console.log(sorted.toString()); 
                ok = grids[currentGridName].indexOf(btnIndex) >= 0;
                if (ok) {


                } else {
                    feedbackElementProps.items[btnIndex].alpha = 1;
                    renderer.view.dispatchEvent(new Event('answerWrong'));

                    currentState = "wrong";
                    setTimeout(onWrong, 500);
                }
            }


            if (currentGridClicks.length === grids[currentGridName].length && _.difference(grids[currentGridName], currentGridClicks).length === 0) {
                renderer.view.dispatchEvent(new Event('answerOk'));
                iterations++;
                setTimeout(okComplete, 1000);
            }

            loopSequence = [renderOnce];
        }

    }

    function onWrong() {
        theGame.cycleGame();
        loopSequence = [renderOnce];
        currentState = "ready";
    }

    function okComplete() {
        if (iterations < 1) {
            setState('newGrid');
        }



        theGame.cycleGame();
        loopSequence = [renderOnce];


    }
}